/** Plain-text excerpt of a (markdown) answer for the share preview card. */
export function shareExcerpt(markdown: string, max = 240): string {
  const text = markdown
    .replace(/```[\s\S]*?```/g, ' ')
    .replace(/`([^`]*)`/g, '$1')
    .replace(/!\[[^\]]*\]\([^)]*\)/g, ' ')
    .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/^\s{0,3}(#{1,6}|>|[-*+]|\d+\.)\s+/gm, '')
    .replace(/[*_~|]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
  return text.length > max ? `${text.slice(0, max).trimEnd()}…` : text;
}

export interface ShareTargets {
  telegram: string;
  whatsapp: string;
  sms: string;
}

/** Deep links for the quick-share buttons. */
export function buildShareTargets(url: string, text: string): ShareTargets {
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(text);
  return {
    telegram: `https://t.me/share/url?url=${u}&text=${t}`,
    whatsapp: `https://wa.me/?text=${encodeURIComponent(`${text}\n${url}`)}`,
    sms: `sms:?&body=${encodeURIComponent(`${text}\n${url}`)}`,
  };
}
